import { AbstractKlesTableService } from "@3kles/kles-material-table";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export abstract class AbstractKlessTreeTableService extends AbstractKlesTableService {
    protected table: any;
    onLineOpen(e: any) { }
    onLineClose(e: any) { }

    public setTable(table: any) {
        this.table = table;
    }

}